import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";

const USE_EMULATORS = process.env.REACT_APP_USE_EMULATORS === "true";

const firebaseConfig = USE_EMULATORS
  ? {
      apiKey: "emulator-key",
      authDomain: "localhost",
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "korea-papualng",
      storageBucket: (process.env.REACT_APP_FIREBASE_PROJECT_ID || "korea-papualng") + ".appspot.com",
    }
  : {
      apiKey:            process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain:        process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId:         process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket:     process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId:             process.env.REACT_APP_FIREBASE_APP_ID,
    };

export let db, auth, storage;
export let FIREBASE_READY = false;
export let STORAGE_READY  = false;

try {
  if (USE_EMULATORS || (firebaseConfig.apiKey && firebaseConfig.projectId)) {
    const app = initializeApp(firebaseConfig);
    db   = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
    FIREBASE_READY = true;
    STORAGE_READY  = true;

    if (USE_EMULATORS) {
      connectFirestoreEmulator(db, "localhost", 8080);
      connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
      connectStorageEmulator(storage, "localhost", 9199);
    }
  }
} catch (e) {
  console.warn("Firebase init failed:", e.message);
}
